import { render } from "./PermissionDenied.vue?vue&type=template&id=6a33f9a9&ts=true"
import script from "./PermissionDenied.vue?vue&type=script&lang=ts"
export * from "./PermissionDenied.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__